import axios from "axios";
import { auth } from "../auth/firebase";
import { env } from "../env";

const axiosNode1Instance = axios.create({
  baseURL: env.REACT_APP_ROBOPOST_NODE1_API_BASE_URL,
  timeout: 600000
});

// Send token with axios
axiosNode1Instance.interceptors.request.use(async config => {
  if (auth.currentUser) {
    const idToken = await auth.currentUser.getIdToken();
    if (idToken) {
      config.headers.authorization = `Bearer ${idToken}`;
    }
  }
  return config;
}, (error) => {
  return Promise.reject(error);
});

export { axiosNode1Instance };
